import axios, { type AxiosRequestHeaders } from "axios";
import { authStore } from "../../store/auth";
import { Toast } from "./toast";
import { get } from "svelte/store";
// import Swal from 'sweetalert2';
import Swal from "sweetalert2/dist/sweetalert2.js";
import { userStore } from "../../store/user";
import { netWorkErrorStore } from "../../store/network_error";
import Loading from "../components/Loading.svelte";
import { Loader } from "./loader";
// import '@sweetalert2/theme-material-ui/material-ui.scss';
// import 'sweetalert2/dist/sweetalert2.min.css';

// import '../sass/sweetalert2.scss';
import packageJson from "../../../package.json";
const version = packageJson.version;

const is_2nd_store = Boolean(Number(import.meta.env.VITE_STORE_2));
const scrip_base_link = import.meta.env.VITE_SCRIP_BASE_LINK;

// const system_version = `ver. ${v}`;

const server_base_url = import.meta.env.VITE_SERVER_URL;
const api_server_base_url = import.meta.env.VITE_API_SERVER_URL;

const apiAxios = axios.create({
  baseURL: api_server_base_url,
  timeout: 5000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
    credentials: "include",
    common: {
      "X-Requested-With": "XMLHttpRequest",
    },
  },
});
const baseAxios = axios.create({
  baseURL: server_base_url,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

const publicAxios = axios.create({
  baseURL: api_server_base_url,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
    common: {
      "X-Requested-With": "XMLHttpRequest",
    },
  },
});

baseAxios.interceptors.response.use(
  (response) => response, // 成功時の処理 今回の例ではresponseを返すだけ
  (error) => {
    // エラー時の処理
    if (error.code === "ERR_NETWORK") {
      netWorkErrorStore.setErrorState();
    }
    return Promise.reject(error.response?.data);
  }
);

apiAxios.interceptors.response.use(
  (response) => response, // 成功時の処理 今回の例ではresponseを返すだけ
  (error) => {
    // エラー時の処理
    if (error.code === "ERR_NETWORK") {
      netWorkErrorStore.setErrorState();
    }
    switch (error.response?.status) {
      //バリデーションエラー
      case 401:
        Toast.error(
          "[Authorize Error] 認証エラーが発生しました。\nページをリロードするか、再度ログインをしてください。"
        );
        return Promise.reject(error.response?.data);
      case 422:
        // Promise reject オブジェクトを必ずリターンする
        popupDecodeError(error.response?.data);
        return Promise.reject(error.response?.data);
      // サーバーエラー
      case 400:
      case 500:
        Toast.error(
          "[Server Error] サーバーでエラーが発生しました。\n解決しない場合は開発者にお知らせください。"
        );
        return Promise.reject(error.response?.data);
      default: // デフォルトの処理
        return Promise.reject(error.response?.data);
    }
  }
);

publicAxios.interceptors.response.use(
  (response) => response, // 成功時の処理 今回の例ではresponseを返すだけ
  (error) => {
    // エラー時の処理
    if (error.code === "ERR_NETWORK") {
      netWorkErrorStore.setErrorState();
    }
    switch (error.response?.status) {
      //バリデーションエラー
      case 422:
        // Promise reject オブジェクトを必ずリターンする
        return Promise.reject(error.response);
      // サーバーエラー
      case 400:
      case 500:
        Toast.error(
          "[Server Error] サーバーでエラーが発生しました。\n解決しない場合は開発者までお知らせください。"
        );
        return Promise.reject(error.response);
      default: // デフォルトの処理
        return Promise.reject(error.response);
    }
  }
);

interface error_422_object {
  errors: {
    [key: string]: string[];
  };
}

function popupDecodeError(error: error_422_object) {
  const messages = [];
  for (const e in error.errors) {
    messages.push(error.errors[e]);
  }
  const message = messages.join("\n");
  Swal.fire("バリデーションエラー", message, "error");
}

async function tryConnectServer() {
  return await baseAxios.get("sanctum/csrf-cookie");
}

tryConnectServer();

function axiosLoginTokenSet(token: string) {
  apiAxios.interceptors.request.use((config) => {
    (<AxiosRequestHeaders>config.headers).Authorization = `Bearer ${token}`;
    return config;
  });
}

async function timer(dulation: number): Promise<void> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, dulation);
  });
}

async function fetchDataVarious(
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE",
  data: any = null
) {
  const token = get(authStore);
  if (token) {
    axiosLoginTokenSet(token);
  }

  if (method === "GET") {
    return await apiAxios
      .get(url, {
        params: data,
      })
      .then((r) => r.data)
      .catch((e) => {
        throw e;
      });
  }

  if (method === "POST") {
    return await apiAxios
      .post(url, data)
      .then((r) => r.data)
      .catch((e) => {
        throw e;
      });
  }

  throw new Error("Non Configure Methods.");
}

function dateTransHyfn(dateObject: Date = new Date()) {
  return new Date(dateObject)
    .toLocaleDateString("ja", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replace(/\//g, "-");
}

function toPrice(numberPrice: null | undefined | number) {
  if (numberPrice === null || numberPrice === undefined) return "";
  const factor = String(numberPrice).split("").reverse();
  return factor
    .map((e, index) => {
      if (index > 1 && index % 3 === 0) {
        return e + ",";
      } else {
        return e;
      }
    })
    .reverse()
    .join("");
}

async function copy(value: string | null) {
  if (value === null || value.length === 0) return;
  await navigator.clipboard.writeText(value).then((r) => {
    return;
  });
}

async function wait(time: number) {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}

type swal2_icon_type = "info" | "warning" | "error" | "question" | "success";
interface swa2_object_option {
  title: string;
  message: string;
  confirm_text: string;
  cancel_text: string;
  icon: swal2_icon_type;
}

async function saConfirm(...args: any | swa2_object_option) {
  let title: string = "";
  let message: string = "";
  let confirm_text: string = "OK";
  let cancel_text: string = "やめる";
  let icon: swal2_icon_type = "info";

  if (Array.isArray(args) && typeof args[0] !== "object") {
    title = args[0] ?? title;
    message = args[1] ?? message;
    confirm_text = args[2] ?? confirm_text;
    cancel_text = args[3] ?? cancel_text;
    icon = args[4] ?? icon;
  } else {
    title = args[0].title ?? title;
    message = args[0].message ?? message;
    confirm_text = args[0].confirm_text ?? confirm_text;
    cancel_text = args[0].cancel_text ?? cancel_text;
    icon = args[0].icon ?? icon;
  }

  return Swal.fire({
    title: title,
    text: message,
    // showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: confirm_text,
    // denyButtonText: cancelText,
    cancelButtonText: cancel_text,
    reverseButtons: true,
    icon: icon,
  }).then((result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      return true;
    } else if (result.isDenied) {
      return false;
    }
  });
}

function makeDummyYearNumbers(): type_code_to_model_year_data[] {
  let start_year = 1981;
  const this_year = new Date().getFullYear();

  return new Array(this_year - start_year).fill(null).map((_, index) => {
    return {
      year_code: "",
      year: start_year + index,
      edited: false,
    };
  });
}

async function checkAuth() {
  try {
    const response = await fetchDataVarious("user", "GET");

    if (response.id) {
      userStore.regist(response);
      return true;
    } else {
      return false;
    }
  } catch (e) {
    if (e.code === "ERR_NETWORK") {
      throw e;
    } else {
      location.assign("/login");
      return false;
    }
  }
}

async function resetToken() {
  await fetchDataVarious("logout", "POST");
  authStore.regist("");
  location.assign("/login");
}

async function publicDataFetch(url: string, data: any = null) {
  return await publicAxios
    .get(url, {
      params: data,
    })
    .then((r) => r.data);
}

function jumpToScripLink(vin: string) {
  const base_url = scrip_base_link;
  const target_link = encodeURI(base_url + vin);
  // console.log(target_link);

  window.open(target_link, "_blank");
}

export {
  // Toast
  Toast,
  // 汎用メソッド
  dateTransHyfn,
  toPrice,
  // 通信系
  apiAxios,
  fetchDataVarious,
  copy,
  wait,
  makeDummyYearNumbers,
  timer,
  saConfirm,
  checkAuth,
  resetToken,
  tryConnectServer,
  publicDataFetch,
  version,
  is_2nd_store,
  jumpToScripLink,
};
